import { ITicketMessage } from "./ticket-message";
import { ITicketTag } from "./ticket-tag";

export interface ITicketForList {
    id: number,
    identifier: string,
    contactId: number,
    subject: string,
    ticketGroupId: number,
    groupName: string,
    groupIsNkr: boolean,
    groupCategory: number,
    assignedUserId: number,
    userName: string,

    entityType: number,
    entityTypeDescription: string,
    entityTypeId: number,

    ticketStatus: number,
    statusDescription: string,
    ticketType: number,
    typeDescription: string,
    tierLevel: number,
    tierDescription: string,
    urgency: number,
    urgencyDescription: string,
    isEmail: boolean,
    createdDateTime: string,
    createdDateTimeForSort: string,
    reopenedDateTime: string,
    resolvedDateTime: string,
    closedDateTime: string,

    isCenter: boolean,
    contactName: string,
    contactEmail: string,
    centerId: number,
    centerAlias: string,
    centerName: string,
    isMemberCenter: boolean,
    message: ITicketMessage,
    tags: ITicketTag[],
    isMissingData: boolean,
    lastUpdatedDateTime: string
}